<template>
  <v-app>
    <router-view/>
  </v-app>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  name: 'App',
  components: {},
  created() {
    this.loadStatuses();
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    ...mapActions('statuses', ['loadStatuses']),
    ...mapMutations('user', ['SET_USER']),

    checkUser() {
      if (this.$storage.get('user-info')) {
        var data = this.$storage.get('user-info');
        console.log('checkUser', data);
        data.v = 1;
        console.log('checkUser', data);
        this.SET_USER(data);
      }
    },
  }
};
</script>

<style lang="sass">
  @import '@/styles/app'
</style>
